<template>
    <a :href="href"
       target="_blank"
       class="opui-btn opui-btn-danger"
    >
        {{ text }}
    </a>
</template>

<script>
export default {
    props: {
        href: { type: String, default: 'https://optimizepress.com/suite-templates' },
        text: { type: String, default: 'Upgrade To Suite' },
    },
}
</script>
